/* eslint-disable no-undef */ const $cb01c403018e8a9a$var$CO2_PER_KWH_IN_DC_GREY = 519;
const $cb01c403018e8a9a$var$CO2_PER_KWH_NETWORK_GREY = 475;
const $cb01c403018e8a9a$var$CO2_PER_KWH_IN_DC_GREEN = 0;
const $cb01c403018e8a9a$var$KWH_PER_BYTE_IN_DC = 72e-12;
const $cb01c403018e8a9a$var$FIXED_NETWORK_WIRED = 429e-12;
const $cb01c403018e8a9a$var$FIXED_NETWORK_WIFI = 152e-12;
const $cb01c403018e8a9a$var$FOUR_G_MOBILE = 884e-12;
const $cb01c403018e8a9a$var$KWH_PER_BYTE_FOR_NETWORK = ($cb01c403018e8a9a$var$FIXED_NETWORK_WIRED + $cb01c403018e8a9a$var$FIXED_NETWORK_WIFI + $cb01c403018e8a9a$var$FOUR_G_MOBILE) / 3;
const $cb01c403018e8a9a$var$KWH_PER_BYTE_FOR_DEVICES = 13e-11;
class $cb01c403018e8a9a$export$fa1a96c8ad196bcc {
    constructor(options){
        this.options = options;
        this.KWH_PER_BYTE_FOR_NETWORK = $cb01c403018e8a9a$var$KWH_PER_BYTE_FOR_NETWORK;
    }
    perByte(bytes, green) {
        if (bytes < 1) return 0;
        if (green) {
            const Co2ForDC = bytes * $cb01c403018e8a9a$var$KWH_PER_BYTE_IN_DC * $cb01c403018e8a9a$var$CO2_PER_KWH_IN_DC_GREEN;
            const Co2forNetwork = bytes * $cb01c403018e8a9a$var$KWH_PER_BYTE_FOR_NETWORK * $cb01c403018e8a9a$var$CO2_PER_KWH_NETWORK_GREY;
            return Co2ForDC + Co2forNetwork;
        }
        const KwHPerByte = $cb01c403018e8a9a$var$KWH_PER_BYTE_IN_DC + $cb01c403018e8a9a$var$KWH_PER_BYTE_FOR_NETWORK;
        return bytes * KwHPerByte * $cb01c403018e8a9a$var$CO2_PER_KWH_IN_DC_GREY;
    }
}
var $cb01c403018e8a9a$export$2e2bcd8739ae039 = $cb01c403018e8a9a$export$fa1a96c8ad196bcc;


const $8c3b35cda1e521bc$var$GIGABYTE = 1000000000;
var $8c3b35cda1e521bc$export$2e2bcd8739ae039 = {
    GIGABYTE: $8c3b35cda1e521bc$var$GIGABYTE
};


const $cc7f173101603ee5$export$4051a07651545597 = {
    "AFG": 132.53,
    "AFRICA": 559.42,
    "ALB": 24.29,
    "DZA": 634.61,
    "ASM": 611.11,
    "AGO": 174.73,
    "ATG": 611.11,
    "ARG": 394.62,
    "ARM": 264.54,
    "ABW": 561.22,
    "ASEAN": 554.5,
    "ASIA": 591.19,
    "AUS": 570.35,
    "AUT": 110.81,
    "AZE": 671.39,
    "BHS": 660.1,
    "BHR": 904.62,
    "BGD": 678.11,
    "BRB": 605.51,
    "BLR": 441.74,
    "BEL": 138.11,
    "BLZ": 225.81,
    "BEN": 584.07,
    "BTN": 23.33,
    "BOL": 489.14,
    "BIH": 600,
    "BWA": 847.91,
    "BRA": 105.51,
    "BRN": 893.91,
    "BGR": 335.33,
    "BFA": 467.53,
    "BDI": 250,
    "CPV": 558.14,
    "KHM": 417.71,
    "CMR": 305.42,
    "CAN": 161.43,
    "CYM": 642.86,
    "CAF": 0,
    "TCD": 628.57,
    "CHL": 353.52,
    "CHN": 585.82,
    "COL": 214.88,
    "COM": 642.86,
    "COG": 700,
    "COD": 24.46,
    "COK": 250,
    "CRI": 26.46,
    "CIV": 393.89,
    "HRV": 204.96,
    "CUB": 637.61,
    "CYP": 534.32,
    "CZE": 449.72,
    "DNK": 151.65,
    "DJI": 692.31,
    "DMA": 529.41,
    "DOM": 580.78,
    "ECU": 150.69,
    "EGY": 570.13,
    "SLV": 116.54,
    "GNQ": 591.84,
    "ERI": 631.58,
    "EST": 416.67,
    "SWZ": 172.41,
    "ETH": 24.64,
    "EU": 243.83,
    "EUROPE": 327.69,
    "FLK": 500,
    "FRO": 404.76,
    "FJI": 288.46,
    "FIN": 79.16,
    "FRA": 56.04,
    "GUF": 217.82,
    "PYF": 442.86,
    "G20": 482.92,
    "G7": 361.52,
    "GAB": 491.6,
    "GMB": 666.67,
    "GEO": 167.02,
    "DEU": 380.95,
    "GHA": 484,
    "GRC": 336.57,
    "GRL": 178.57,
    "GRD": 640,
    "GLP": 500,
    "GUM": 622.86,
    "GTM": 328.27,
    "GIN": 236.84,
    "GNB": 625,
    "GUY": 640.35,
    "HTI": 567.31,
    "HND": 282.27,
    "HKG": 699.5,
    "HUN": 204.19,
    "ISL": 27.68,
    "IND": 705.13,
    "IDN": 675.93,
    "IRN": 665.15,
    "IRQ": 688.81,
    "IRL": 290.81,
    "ISR": 582.93,
    "ITA": 330.72,
    "JAM": 555.56,
    "JPN": 512.81,
    "JOR": 540.92,
    "KAZ": 830.41,
    "KEN": 83.33,
    "KIR": 666.67,
    "XKX": 894.65,
    "KWT": 649.2,
    "KGZ": 147.29,
    "LAO": 265.51,
    "LATIN AMERICA AND CARIBBEAN": 260.28,
    "LVA": 123.2,
    "LBN": 599.01,
    "LSO": 20,
    "LBR": 227.85,
    "LBY": 818.69,
    "LTU": 160.07,
    "LUX": 105.26,
    "MAC": 448.98,
    "MDG": 436.44,
    "MWI": 66.67,
    "MYS": 605.83,
    "MDV": 611.77,
    "MLI": 408,
    "MLT": 459.14,
    "MTQ": 523.18,
    "MRT": 464.71,
    "MUS": 632.48,
    "MEX": 475.36,
    "MIDDLE EAST": 660.46,
    "MDA": 648.5,
    "MNG": 771.8,
    "MNE": 417.07,
    "MSR": 1e3,
    "MAR": 662.64,
    "MOZ": 135.65,
    "MMR": 483.57,
    "NAM": 59.26,
    "NRU": 750,
    "NPL": 24.44,
    "NLD": 267.62,
    "NCL": 660.58,
    "NZL": 110.89,
    "NIC": 265.12,
    "NER": 670.89,
    "NGA": 516.23,
    "NORTH AMERICA": 356.01,
    "PRK": 389.59,
    "MKD": 565.35,
    "NOR": 30.08,
    "OCEANIA": 507.63,
    "OECD": 360.53,
    "OMN": 564.69,
    "PAK": 463.66,
    "PSE": 516.13,
    "PAN": 161.68,
    "PNG": 507.25,
    "PRY": 24.31,
    "PER": 251.74,
    "POL": 661.93,
    "PRT": 165.55,
    "PRI": 678.74,
    "QAT": 602.59,
    "REU": 572.82,
    "ROU": 240.58,
    "RUS": 436.28,
    "RWA": 316.33,
    "KNA": 636.36,
    "LCA": 666.67,
    "SPM": 600,
    "VCT": 529.41,
    "WSM": 473.68,
    "STP": 642.86,
    "SAU": 706.79,
    "SEN": 511.6,
    "SRB": 636.06,
    "SYC": 564.52,
    "SLE": 50,
    "SGP": 474,
    "SVK": 116.77,
    "SVN": 231.28,
    "SLB": 700,
    "SOM": 578.95,
    "ZAF": 729.67,
    "KOR": 441.65,
    "SSD": 629.03,
    "ESP": 174.05,
    "LKA": 509.78,
    "SDN": 263.16,
    "SUR": 349.28,
    "SWE": 40.7,
    "CHE": 34.84,
    "SYR": 701.66,
    "TWN": 639.53,
    "TJK": 116.86,
    "TZA": 339.25,
    "THA": 560.74,
    "PHL": 601.1,
    "TGO": 443.18,
    "TON": 625,
    "TTO": 681.53,
    "TUN": 564.62,
    "TUR": 464.59,
    "TKM": 1306.03,
    "TCA": 653.85,
    "UGA": 44.53,
    "UKR": 259.69,
    "ARE": 561.14,
    "GBR": 237.59,
    "USA": 385.98,
    "URY": 112.65,
    "UZB": 1167.6,
    "VUT": 571.43,
    "VEN": 185.8,
    "VNM": 409.8,
    "VGB": 647.06,
    "VIR": 632.35,
    "WORLD": 485.99,
    "YEM": 566.1,
    "ZMB": 111.97,
    "ZWE": 297.87
};
const $cc7f173101603ee5$export$bf9fb029d174d554 = "average";
var $cc7f173101603ee5$export$2e2bcd8739ae039 = {
    data: $cc7f173101603ee5$export$4051a07651545597,
    type: $cc7f173101603ee5$export$bf9fb029d174d554
};


const $5da942dbe8cde8d3$export$6d9278a4e9c49494 = 0.81;
const $5da942dbe8cde8d3$export$f2b22cdde248e110 = 0.52;
const $5da942dbe8cde8d3$export$185a45ac74abe2c1 = 0.14;
const $5da942dbe8cde8d3$export$8f3b9bdea6bdfcdd = 0.15;
const $5da942dbe8cde8d3$export$42474697fd1b705 = 0.19;
const $5da942dbe8cde8d3$export$8e64e490f4b794c3 = (0, $cc7f173101603ee5$export$2e2bcd8739ae039).data["WORLD"];
const $5da942dbe8cde8d3$export$a112b70136da2c26 = 50;
const $5da942dbe8cde8d3$export$ce20e865b4b751ec = 0.75;
const $5da942dbe8cde8d3$export$b0e6f87c169c1860 = 0.25;
const $5da942dbe8cde8d3$export$759579eabe5fce4d = 0.02;




const $f24e1422d218d520$export$f5dd818bff069720 = (num)=>parseFloat(num.toFixed(2));
function $f24e1422d218d520$export$49fe41a914eb071d(options) {
    var _a, _b, _c, _d, _e, _f;
    if (typeof options !== "object") throw new Error("Options must be an object");
    const adjustments = {};
    if (options == null ? void 0 : options.gridIntensity) {
        adjustments.gridIntensity = {};
        const { device: device, dataCenter: dataCenter, network: network } = options.gridIntensity;
        if (device || device === 0) {
            if (typeof device === "object") {
                if (!(0, $cc7f173101603ee5$export$2e2bcd8739ae039).data[(_a = device.country) == null ? void 0 : _a.toUpperCase()]) {
                    console.warn(`"${device.country}" is not a valid country. Please use a valid 3 digit ISO 3166 country code. 
See https://developers.thegreenwebfoundation.org/co2js/data/ for more information. 
Falling back to global average grid intensity.`);
                    adjustments.gridIntensity["device"] = {
                        value: (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3)
                    };
                }
                adjustments.gridIntensity["device"] = {
                    country: device.country,
                    value: parseFloat((0, $cc7f173101603ee5$export$2e2bcd8739ae039).data[(_b = device.country) == null ? void 0 : _b.toUpperCase()])
                };
            } else if (typeof device === "number") adjustments.gridIntensity["device"] = {
                value: device
            };
            else {
                adjustments.gridIntensity["device"] = {
                    value: (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3)
                };
                console.warn(`The device grid intensity must be a number or an object. You passed in a ${typeof device}. 
Falling back to global average grid intensity.`);
            }
        }
        if (dataCenter || dataCenter === 0) {
            if (typeof dataCenter === "object") {
                if (!(0, $cc7f173101603ee5$export$2e2bcd8739ae039).data[(_c = dataCenter.country) == null ? void 0 : _c.toUpperCase()]) {
                    console.warn(`"${dataCenter.country}" is not a valid country. Please use a valid 3 digit ISO 3166 country code. 
See https://developers.thegreenwebfoundation.org/co2js/data/ for more information.  
Falling back to global average grid intensity.`);
                    adjustments.gridIntensity["dataCenter"] = {
                        value: (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3)
                    };
                }
                adjustments.gridIntensity["dataCenter"] = {
                    country: dataCenter.country,
                    value: parseFloat((0, $cc7f173101603ee5$export$2e2bcd8739ae039).data[(_d = dataCenter.country) == null ? void 0 : _d.toUpperCase()])
                };
            } else if (typeof dataCenter === "number") adjustments.gridIntensity["dataCenter"] = {
                value: dataCenter
            };
            else {
                adjustments.gridIntensity["dataCenter"] = {
                    value: (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3)
                };
                console.warn(`The data center grid intensity must be a number or an object. You passed in a ${typeof dataCenter}. 
Falling back to global average grid intensity.`);
            }
        }
        if (network || network === 0) {
            if (typeof network === "object") {
                if (!(0, $cc7f173101603ee5$export$2e2bcd8739ae039).data[(_e = network.country) == null ? void 0 : _e.toUpperCase()]) {
                    console.warn(`"${network.country}" is not a valid country. Please use a valid 3 digit ISO 3166 country code. 
See https://developers.thegreenwebfoundation.org/co2js/data/ for more information.  Falling back to global average grid intensity. 
Falling back to global average grid intensity.`);
                    adjustments.gridIntensity["network"] = {
                        value: (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3)
                    };
                }
                adjustments.gridIntensity["network"] = {
                    country: network.country,
                    value: parseFloat((0, $cc7f173101603ee5$export$2e2bcd8739ae039).data[(_f = network.country) == null ? void 0 : _f.toUpperCase()])
                };
            } else if (typeof network === "number") adjustments.gridIntensity["network"] = {
                value: network
            };
            else {
                adjustments.gridIntensity["network"] = {
                    value: (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3)
                };
                console.warn(`The network grid intensity must be a number or an object. You passed in a ${typeof network}. 
Falling back to global average grid intensity.`);
            }
        }
    }
    if ((options == null ? void 0 : options.dataReloadRatio) || options.dataReloadRatio === 0) {
        if (typeof options.dataReloadRatio === "number") {
            if (options.dataReloadRatio >= 0 && options.dataReloadRatio <= 1) adjustments.dataReloadRatio = options.dataReloadRatio;
            else {
                adjustments.dataReloadRatio = (0, $5da942dbe8cde8d3$export$759579eabe5fce4d);
                console.warn(`The dataReloadRatio option must be a number between 0 and 1. You passed in ${options.dataReloadRatio}. 
Falling back to default value.`);
            }
        } else {
            adjustments.dataReloadRatio = (0, $5da942dbe8cde8d3$export$759579eabe5fce4d);
            console.warn(`The dataReloadRatio option must be a number. You passed in a ${typeof options.dataReloadRatio}. 
Falling back to default value.`);
        }
    }
    if ((options == null ? void 0 : options.firstVisitPercentage) || options.firstVisitPercentage === 0) {
        if (typeof options.firstVisitPercentage === "number") {
            if (options.firstVisitPercentage >= 0 && options.firstVisitPercentage <= 1) adjustments.firstVisitPercentage = options.firstVisitPercentage;
            else {
                adjustments.firstVisitPercentage = (0, $5da942dbe8cde8d3$export$ce20e865b4b751ec);
                console.warn(`The firstVisitPercentage option must be a number between 0 and 1. You passed in ${options.firstVisitPercentage}. 
Falling back to default value.`);
            }
        } else {
            adjustments.firstVisitPercentage = (0, $5da942dbe8cde8d3$export$ce20e865b4b751ec);
            console.warn(`The firstVisitPercentage option must be a number. You passed in a ${typeof options.firstVisitPercentage}. 
Falling back to default value.`);
        }
    }
    if ((options == null ? void 0 : options.returnVisitPercentage) || options.returnVisitPercentage === 0) {
        if (typeof options.returnVisitPercentage === "number") {
            if (options.returnVisitPercentage >= 0 && options.returnVisitPercentage <= 1) adjustments.returnVisitPercentage = options.returnVisitPercentage;
            else {
                adjustments.returnVisitPercentage = (0, $5da942dbe8cde8d3$export$b0e6f87c169c1860);
                console.warn(`The returnVisitPercentage option must be a number between 0 and 1. You passed in ${options.returnVisitPercentage}. 
Falling back to default value.`);
            }
        } else {
            adjustments.returnVisitPercentage = (0, $5da942dbe8cde8d3$export$b0e6f87c169c1860);
            console.warn(`The returnVisitPercentage option must be a number. You passed in a ${typeof options.returnVisitPercentage}. 
Falling back to default value.`);
        }
    }
    return adjustments;
}
function $f24e1422d218d520$export$10dc543a2de8a5fa(comment = "") {
    return {
        "User-Agent": `co2js/${"0.15.0"} ${comment}`
    };
}


"use strict";
var $fdfb9f0af82e6266$var$__defProp = Object.defineProperty;
var $fdfb9f0af82e6266$var$__defProps = Object.defineProperties;
var $fdfb9f0af82e6266$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $fdfb9f0af82e6266$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $fdfb9f0af82e6266$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $fdfb9f0af82e6266$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $fdfb9f0af82e6266$var$__defNormalProp = (obj, key, value)=>key in obj ? $fdfb9f0af82e6266$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $fdfb9f0af82e6266$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($fdfb9f0af82e6266$var$__hasOwnProp.call(b, prop)) $fdfb9f0af82e6266$var$__defNormalProp(a, prop, b[prop]);
    if ($fdfb9f0af82e6266$var$__getOwnPropSymbols) {
        for (var prop of $fdfb9f0af82e6266$var$__getOwnPropSymbols(b))if ($fdfb9f0af82e6266$var$__propIsEnum.call(b, prop)) $fdfb9f0af82e6266$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $fdfb9f0af82e6266$var$__spreadProps = (a, b)=>$fdfb9f0af82e6266$var$__defProps(a, $fdfb9f0af82e6266$var$__getOwnPropDescs(b));
class $fdfb9f0af82e6266$export$470c8facaf32b0b5 {
    constructor(options){
        this.options = options;
    }
    energyPerByteByComponent(bytes) {
        const transferedBytesToGb = bytes / (0, $8c3b35cda1e521bc$export$2e2bcd8739ae039).GIGABYTE;
        const energyUsage = transferedBytesToGb * (0, $5da942dbe8cde8d3$export$6d9278a4e9c49494);
        return {
            consumerDeviceEnergy: energyUsage * (0, $5da942dbe8cde8d3$export$f2b22cdde248e110),
            networkEnergy: energyUsage * (0, $5da942dbe8cde8d3$export$185a45ac74abe2c1),
            productionEnergy: energyUsage * (0, $5da942dbe8cde8d3$export$42474697fd1b705),
            dataCenterEnergy: energyUsage * (0, $5da942dbe8cde8d3$export$8f3b9bdea6bdfcdd)
        };
    }
    co2byComponent(energyByComponent, carbonIntensity = (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3), options = {}) {
        let deviceCarbonIntensity = (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3);
        let networkCarbonIntensity = (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3);
        let dataCenterCarbonIntensity = (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3);
        let globalEmissions = (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3);
        if (options == null ? void 0 : options.gridIntensity) {
            const { device: device, network: network, dataCenter: dataCenter } = options.gridIntensity;
            if ((device == null ? void 0 : device.value) || (device == null ? void 0 : device.value) === 0) deviceCarbonIntensity = device.value;
            if ((network == null ? void 0 : network.value) || (network == null ? void 0 : network.value) === 0) networkCarbonIntensity = network.value;
            if ((dataCenter == null ? void 0 : dataCenter.value) || (dataCenter == null ? void 0 : dataCenter.value) === 0) dataCenterCarbonIntensity = dataCenter.value;
        }
        if (carbonIntensity === true) dataCenterCarbonIntensity = (0, $5da942dbe8cde8d3$export$a112b70136da2c26);
        const returnCO2ByComponent = {};
        for (const [key, value] of Object.entries(energyByComponent)){
            if (key.startsWith("dataCenterEnergy")) returnCO2ByComponent[key.replace("Energy", "CO2")] = value * dataCenterCarbonIntensity;
            else if (key.startsWith("consumerDeviceEnergy")) returnCO2ByComponent[key.replace("Energy", "CO2")] = value * deviceCarbonIntensity;
            else if (key.startsWith("networkEnergy")) returnCO2ByComponent[key.replace("Energy", "CO2")] = value * networkCarbonIntensity;
            else returnCO2ByComponent[key.replace("Energy", "CO2")] = value * globalEmissions;
        }
        return returnCO2ByComponent;
    }
    perByte(bytes, carbonIntensity = false, segmentResults = false, options = {}) {
        if (bytes < 1) bytes = 0;
        const energyBycomponent = this.energyPerByteByComponent(bytes, options);
        if (typeof carbonIntensity !== "boolean") throw new Error(`perByte expects a boolean for the carbon intensity value. Received: ${carbonIntensity}`);
        const co2ValuesbyComponent = this.co2byComponent(energyBycomponent, carbonIntensity, options);
        const co2Values = Object.values(co2ValuesbyComponent);
        const co2ValuesSum = co2Values.reduce((prevValue, currentValue)=>prevValue + currentValue);
        if (segmentResults) return $fdfb9f0af82e6266$var$__spreadProps($fdfb9f0af82e6266$var$__spreadValues({}, co2ValuesbyComponent), {
            total: co2ValuesSum
        });
        return co2ValuesSum;
    }
    perVisit(bytes, carbonIntensity = false, segmentResults = false, options = {}) {
        const energyBycomponent = this.energyPerVisitByComponent(bytes, options);
        if (typeof carbonIntensity !== "boolean") throw new Error(`perVisit expects a boolean for the carbon intensity value. Received: ${carbonIntensity}`);
        const co2ValuesbyComponent = this.co2byComponent(energyBycomponent, carbonIntensity, options);
        const co2Values = Object.values(co2ValuesbyComponent);
        const co2ValuesSum = co2Values.reduce((prevValue, currentValue)=>prevValue + currentValue);
        if (segmentResults) return $fdfb9f0af82e6266$var$__spreadProps($fdfb9f0af82e6266$var$__spreadValues({}, co2ValuesbyComponent), {
            total: co2ValuesSum
        });
        return co2ValuesSum;
    }
    energyPerByte(bytes) {
        const energyByComponent = this.energyPerByteByComponent(bytes);
        const energyValues = Object.values(energyByComponent);
        return energyValues.reduce((prevValue, currentValue)=>prevValue + currentValue);
    }
    energyPerVisitByComponent(bytes, options = {}, firstView = (0, $5da942dbe8cde8d3$export$ce20e865b4b751ec), returnView = (0, $5da942dbe8cde8d3$export$b0e6f87c169c1860), dataReloadRatio = (0, $5da942dbe8cde8d3$export$759579eabe5fce4d)) {
        if (options.dataReloadRatio || options.dataReloadRatio === 0) dataReloadRatio = options.dataReloadRatio;
        if (options.firstVisitPercentage || options.firstVisitPercentage === 0) firstView = options.firstVisitPercentage;
        if (options.returnVisitPercentage || options.returnVisitPercentage === 0) returnView = options.returnVisitPercentage;
        const energyBycomponent = this.energyPerByteByComponent(bytes);
        const cacheAdjustedSegmentEnergy = {};
        const energyValues = Object.values(energyBycomponent);
        for (const [key, value] of Object.entries(energyBycomponent)){
            cacheAdjustedSegmentEnergy[`${key} - first`] = value * firstView;
            cacheAdjustedSegmentEnergy[`${key} - subsequent`] = value * returnView * dataReloadRatio;
        }
        return cacheAdjustedSegmentEnergy;
    }
    energyPerVisit(bytes) {
        let firstVisits = 0;
        let subsequentVisits = 0;
        const energyBycomponent = Object.entries(this.energyPerVisitByComponent(bytes));
        for (const [key, val] of energyBycomponent)if (key.indexOf("first") > 0) firstVisits += val;
        for (const [key, val] of energyBycomponent)if (key.indexOf("subsequent") > 0) subsequentVisits += val;
        return firstVisits + subsequentVisits;
    }
    emissionsPerVisitInGrams(energyPerVisit, carbonintensity = (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3)) {
        return (0, $f24e1422d218d520$export$f5dd818bff069720)(energyPerVisit * carbonintensity);
    }
    annualEnergyInKwh(energyPerVisit, monthlyVisitors = 1e3) {
        return energyPerVisit * monthlyVisitors * 12;
    }
    annualEmissionsInGrams(co2grams, monthlyVisitors = 1e3) {
        return co2grams * monthlyVisitors * 12;
    }
    annualSegmentEnergy(annualEnergy) {
        return {
            consumerDeviceEnergy: (0, $f24e1422d218d520$export$f5dd818bff069720)(annualEnergy * (0, $5da942dbe8cde8d3$export$f2b22cdde248e110)),
            networkEnergy: (0, $f24e1422d218d520$export$f5dd818bff069720)(annualEnergy * (0, $5da942dbe8cde8d3$export$185a45ac74abe2c1)),
            dataCenterEnergy: (0, $f24e1422d218d520$export$f5dd818bff069720)(annualEnergy * (0, $5da942dbe8cde8d3$export$8f3b9bdea6bdfcdd)),
            productionEnergy: (0, $f24e1422d218d520$export$f5dd818bff069720)(annualEnergy * (0, $5da942dbe8cde8d3$export$42474697fd1b705))
        };
    }
}
var $fdfb9f0af82e6266$export$2e2bcd8739ae039 = $fdfb9f0af82e6266$export$470c8facaf32b0b5;




"use strict";
class $919f990d3a3bf3ae$export$671274ae6d120192 {
    constructor(options){
        this.model = new (0, $fdfb9f0af82e6266$export$2e2bcd8739ae039)();
        if ((options == null ? void 0 : options.model) === "1byte") this.model = new (0, $cb01c403018e8a9a$export$2e2bcd8739ae039)();
        else if ((options == null ? void 0 : options.model) === "swd") this.model = new (0, $fdfb9f0af82e6266$export$2e2bcd8739ae039)();
        else if (options == null ? void 0 : options.model) throw new Error(`"${options.model}" is not a valid model. Please use "1byte" for the OneByte model, and "swd" for the Sustainable Web Design model.
See https://developers.thegreenwebfoundation.org/co2js/models/ to learn more about the models available in CO2.js.`);
        this._segment = (options == null ? void 0 : options.results) === "segment";
    }
    perByte(bytes, green = false) {
        return this.model.perByte(bytes, green, this._segment);
    }
    perVisit(bytes, green = false) {
        var _a;
        if ((_a = this.model) == null ? void 0 : _a.perVisit) return this.model.perVisit(bytes, green, this._segment);
        else throw new Error(`The perVisit() method is not supported in the model you are using. Try using perByte() instead.
See https://developers.thegreenwebfoundation.org/co2js/methods/ to learn more about the methods available in CO2.js.`);
    }
    perByteTrace(bytes, green = false, options = {}) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        let adjustments = {};
        if (options) adjustments = (0, $f24e1422d218d520$export$49fe41a914eb071d)(options);
        return {
            co2: this.model.perByte(bytes, green, this._segment, adjustments),
            green: green,
            variables: {
                description: "Below are the variables used to calculate this CO2 estimate.",
                bytes: bytes,
                gridIntensity: {
                    description: "The grid intensity (grams per kilowatt-hour) used to calculate this CO2 estimate.",
                    network: (_c = (_b = (_a = adjustments == null ? void 0 : adjustments.gridIntensity) == null ? void 0 : _a.network) == null ? void 0 : _b.value) != null ? _c : (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3),
                    dataCenter: green ? (0, $5da942dbe8cde8d3$export$a112b70136da2c26) : (_f = (_e = (_d = adjustments == null ? void 0 : adjustments.gridIntensity) == null ? void 0 : _d.dataCenter) == null ? void 0 : _e.value) != null ? _f : (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3),
                    production: (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3),
                    device: (_i = (_h = (_g = adjustments == null ? void 0 : adjustments.gridIntensity) == null ? void 0 : _g.device) == null ? void 0 : _h.value) != null ? _i : (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3)
                }
            }
        };
    }
    perVisitTrace(bytes, green = false, options = {}) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
        if ((_a = this.model) == null ? void 0 : _a.perVisit) {
            let adjustments = {};
            if (options) adjustments = (0, $f24e1422d218d520$export$49fe41a914eb071d)(options);
            return {
                co2: this.model.perVisit(bytes, green, this._segment, adjustments),
                green: green,
                variables: {
                    description: "Below are the variables used to calculate this CO2 estimate.",
                    bytes: bytes,
                    gridIntensity: {
                        description: "The grid intensity (grams per kilowatt-hour) used to calculate this CO2 estimate.",
                        network: (_d = (_c = (_b = adjustments == null ? void 0 : adjustments.gridIntensity) == null ? void 0 : _b.network) == null ? void 0 : _c.value) != null ? _d : (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3),
                        dataCenter: green ? (0, $5da942dbe8cde8d3$export$a112b70136da2c26) : (_g = (_f = (_e = adjustments == null ? void 0 : adjustments.gridIntensity) == null ? void 0 : _e.dataCenter) == null ? void 0 : _f.value) != null ? _g : (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3),
                        production: (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3),
                        device: (_j = (_i = (_h = adjustments == null ? void 0 : adjustments.gridIntensity) == null ? void 0 : _h.device) == null ? void 0 : _i.value) != null ? _j : (0, $5da942dbe8cde8d3$export$8e64e490f4b794c3)
                    },
                    dataReloadRatio: (_k = adjustments == null ? void 0 : adjustments.dataReloadRatio) != null ? _k : 0.02,
                    firstVisitPercentage: (_l = adjustments == null ? void 0 : adjustments.firstVisitPercentage) != null ? _l : 0.75,
                    returnVisitPercentage: (_m = adjustments == null ? void 0 : adjustments.returnVisitPercentage) != null ? _m : 0.25
                }
            };
        } else throw new Error(`The perVisitDetailed() method is not supported in the model you are using. Try using perByte() instead.
See https://developers.thegreenwebfoundation.org/co2js/methods/ to learn more about the methods available in CO2.js.`);
    }
}
var $919f990d3a3bf3ae$export$2e2bcd8739ae039 = $919f990d3a3bf3ae$export$671274ae6d120192;



"use strict";
var $4a387ac41c1679bc$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $4a387ac41c1679bc$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$4a387ac41c1679bc$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $4a387ac41c1679bc$var$require_hosting_json = $4a387ac41c1679bc$var$__commonJS({
    "src/hosting-json.js" (exports, module) {
        async function check(domain, db) {
            if (typeof domain === "string") return checkInJSON(domain, db);
            else return checkDomainsInJSON(domain, db);
        }
        function checkInJSON(domain, db) {
            if (db.indexOf(domain) > -1) return true;
            return false;
        }
        function greenDomainsFromResults(greenResults) {
            const entries = Object.entries(greenResults);
            const greenEntries = entries.filter(([key, val])=>val.green);
            return greenEntries.map(([key, val])=>val.url);
        }
        function checkDomainsInJSON(domains, db) {
            let greenDomains = [];
            for (let domain of domains)if (db.indexOf(domain) > -1) greenDomains.push(domain);
            return greenDomains;
        }
        function find(domain, db) {
            if (typeof domain === "string") return findInJSON(domain, db);
            else return findDomainsInJSON(domain, db);
        }
        function findInJSON(domain, db) {
            if (db.indexOf(domain) > -1) return domain;
            return {
                url: domain,
                green: false
            };
        }
        function findDomainsInJSON(domains, db) {
            const result = {};
            for (let domain of domains)result[domain] = findInJSON(domain, db);
            return result;
        }
        module.exports = {
            check: check,
            greenDomainsFromResults: greenDomainsFromResults,
            find: find
        };
    }
});
var $4a387ac41c1679bc$export$2e2bcd8739ae039 = $4a387ac41c1679bc$var$require_hosting_json();


"use strict";
function $8e4d4cbdf7b44800$var$check(domain, optionsOrAgentId) {
    const options = typeof optionsOrAgentId === "string" ? {
        userAgentIdentifier: optionsOrAgentId
    } : optionsOrAgentId;
    if ((options == null ? void 0 : options.db) && options.verbose) throw new Error("verbose mode cannot be used with a local lookup database");
    if (typeof domain === "string") return $8e4d4cbdf7b44800$var$checkAgainstAPI(domain, options);
    else return $8e4d4cbdf7b44800$var$checkDomainsAgainstAPI(domain, options);
}
async function $8e4d4cbdf7b44800$var$checkAgainstAPI(domain, options = {}) {
    const req = await fetch(`https://api.thegreenwebfoundation.org/greencheck/${domain}`, {
        headers: (0, $f24e1422d218d520$export$10dc543a2de8a5fa)(options.userAgentIdentifier)
    });
    if (options == null ? void 0 : options.db) return (0, $4a387ac41c1679bc$export$2e2bcd8739ae039).check(domain, options.db);
    const res = await req.json();
    return options.verbose ? res : res.green;
}
async function $8e4d4cbdf7b44800$var$checkDomainsAgainstAPI(domains, options = {}) {
    try {
        const apiPath = "https://api.thegreenwebfoundation.org/v2/greencheckmulti";
        const domainsString = JSON.stringify(domains);
        const req = await fetch(`${apiPath}/${domainsString}`, {
            headers: (0, $f24e1422d218d520$export$10dc543a2de8a5fa)(options.userAgentIdentifier)
        });
        const allGreenCheckResults = await req.json();
        return options.verbose ? allGreenCheckResults : $8e4d4cbdf7b44800$var$greenDomainsFromResults(allGreenCheckResults);
    } catch (e) {
        return options.verbose ? {} : [];
    }
}
function $8e4d4cbdf7b44800$var$greenDomainsFromResults(greenResults) {
    const entries = Object.entries(greenResults);
    const greenEntries = entries.filter(([key, val])=>val.green);
    return greenEntries.map(([key, val])=>val.url);
}
var $8e4d4cbdf7b44800$export$2e2bcd8739ae039 = {
    check: $8e4d4cbdf7b44800$var$check
};


"use strict";
function $bec6b2fd1d53da18$var$check(domain, optionsOrAgentId) {
    return (0, $8e4d4cbdf7b44800$export$2e2bcd8739ae039).check(domain, optionsOrAgentId);
}
var $bec6b2fd1d53da18$export$2e2bcd8739ae039 = {
    check: $bec6b2fd1d53da18$var$check
};



const $28420642a49bc9db$export$4051a07651545597 = {
    "AFG": "414",
    "ALB": "0",
    "DZA": "528",
    "ASM": "753",
    "AND": "188",
    "AGO": "1476",
    "AIA": "753",
    "ATG": "753",
    "ARG": "478",
    "ARM": "390",
    "ABW": "753",
    "AUS": "808",
    "AUT": "242",
    "AZE": "534",
    "AZORES (PORTUGAL)": "753",
    "BHS": "753",
    "BHR": "726",
    "BGD": "528",
    "BRB": "749",
    "BLR": "400",
    "BEL": "252",
    "BLZ": "403",
    "BEN": "745",
    "BMU": "753",
    "BTN": "0",
    "BOL": "604",
    "BES": "753",
    "BIH": "1197",
    "BWA": "1486",
    "BRA": "284",
    "VGB": "753",
    "BRN": "681",
    "BGR": "911",
    "BFA": "753",
    "BDI": "414",
    "KHM": "1046",
    "CMR": "659",
    "CAN": "372",
    "CYM": "753",
    "CPV": "753",
    "CAF": "188",
    "TCD": "753",
    "CHANNEL ISLANDS (U.K)": "753",
    "CHL": "657",
    "CHN": "899",
    "COL": "410",
    "COM": "753",
    "COD": "0",
    "COG": "659",
    "COK": "753",
    "CRI": "108",
    "CIV": "466",
    "HRV": "294",
    "CUB": "559",
    "CUW": "876",
    "CYP": "751",
    "CZE": "902",
    "DNK": "362",
    "DJI": "753",
    "DMA": "753",
    "DOM": "601",
    "ECU": "560",
    "EGY": "554",
    "SLV": "547",
    "GNQ": "632",
    "ERI": "915",
    "EST": "1057",
    "SWZ": "0",
    "ETH": "0",
    "FLK": "753",
    "FRO": "753",
    "FJI": "640",
    "FIN": "267",
    "FRA": "158",
    "GUF": "423",
    "PYF": "753",
    "GAB": "946",
    "GMB": "753",
    "GEO": "289",
    "DEU": "650",
    "GHA": "495",
    "GIB": "779",
    "GRC": "507",
    "GRL": "264",
    "GRD": "753",
    "GLP": "753",
    "GUM": "753",
    "GTM": "798",
    "GIN": "753",
    "GNB": "753",
    "GUY": "847",
    "HTI": "1048",
    "HND": "662",
    "HUN": "296",
    "ISL": "0",
    "IND": "951",
    "IDN": "783",
    "IRN": "592",
    "IRQ": "1080",
    "IRL": "380",
    "IMN": "436",
    "ISR": "394",
    "ITA": "414",
    "JAM": "711",
    "JPN": "471",
    "JOR": "529",
    "KAZ": "797",
    "KEN": "574",
    "KIR": "753",
    "PRK": "754",
    "KOR": "555",
    "XKX": "1145",
    "KWT": "675",
    "KGZ": "217",
    "LAO": "1069",
    "LVA": "240",
    "LBN": "794",
    "LSO": "0",
    "LBR": "677",
    "LBY": "668",
    "LIE": "151",
    "LTU": "211",
    "LUX": "220",
    "MDG": "876",
    "MADEIRA (PORTUGAL)": "663",
    "MWI": "489",
    "MYS": "551",
    "MDV": "753",
    "MLI": "1076",
    "MLT": "520",
    "MHL": "753",
    "MTQ": "753",
    "MRT": "753",
    "MUS": "700",
    "MYT": "753",
    "MEX": "531",
    "FSM": "753",
    "MDA": "541",
    "MCO": "158",
    "MNG": "1366",
    "MNE": "899",
    "MSR": "753",
    "MAR": "729",
    "MOZ": "234",
    "MMR": "719",
    "NAM": "355",
    "NRU": "753",
    "NPL": "0",
    "NLD": "326",
    "NCL": "779",
    "NZL": "246",
    "NIC": "675",
    "NER": "772",
    "NGA": "526",
    "NIU": "753",
    "MKD": "851",
    "MNP": "753",
    "NOR": "47",
    "OMN": "479",
    "PAK": "592",
    "PLW": "753",
    "PSE": "719",
    "PAN": "477",
    "PNG": "597",
    "PRY": "0",
    "PER": "473",
    "PHL": "672",
    "POL": "828",
    "PRT": "389",
    "PRI": "596",
    "QAT": "503",
    "REU": "772",
    "ROU": "489",
    "RUS": "476",
    "RWA": "712",
    "SHN": "753",
    "KNA": "753",
    "LCA": "753",
    "MAF": "753",
    "SPM": "753",
    "VCT": "753",
    "WSM": "753",
    "SMR": "414",
    "STP": "753",
    "SAU": "592",
    "SEN": "870",
    "SRB": "1086",
    "SYC": "753",
    "SLE": "489",
    "SGP": "379",
    "SXM": "753",
    "SVK": "332",
    "SVN": "620",
    "SLB": "753",
    "SOM": "753",
    "ZAF": "1070",
    "SSD": "890",
    "ESP": "402",
    "LKA": "731",
    "SDN": "736",
    "SUR": "1029",
    "SWE": "68",
    "CHE": "48",
    "SYR": "713",
    "TWN": "484",
    "TJK": "255",
    "TZA": "531",
    "THA": "450",
    "TLS": "753",
    "TGO": "859",
    "TON": "753",
    "TTO": "559",
    "TUN": "468",
    "TUR": "376",
    "TKM": "927",
    "TCA": "753",
    "TUV": "753",
    "UGA": "279",
    "UKR": "768",
    "ARE": "556",
    "GBR": "380",
    "USA": "416",
    "URY": "174",
    "UZB": "612",
    "VUT": "753",
    "VEN": "711",
    "VNM": "560",
    "VIR": "650",
    "YEM": "807",
    "ZMB": "416",
    "ZWE": "1575",
    "MEMO:  EU 27": "409"
};
const $28420642a49bc9db$export$bf9fb029d174d554 = "marginal";
const $28420642a49bc9db$export$31803937850fb2da = "2021";
var $28420642a49bc9db$export$2e2bcd8739ae039 = {
    data: $28420642a49bc9db$export$4051a07651545597,
    type: $28420642a49bc9db$export$bf9fb029d174d554,
    year: $28420642a49bc9db$export$31803937850fb2da
};


var $310158a4e74e07eb$export$2e2bcd8739ae039 = {
    co2: $919f990d3a3bf3ae$export$2e2bcd8739ae039,
    hosting: $bec6b2fd1d53da18$export$2e2bcd8739ae039,
    averageIntensity: $cc7f173101603ee5$export$2e2bcd8739ae039,
    marginalIntensity: $28420642a49bc9db$export$2e2bcd8739ae039
};


const $cf79059e4e797253$var$URL = "www.ifieldnotes.org";
// See https://www.thegreenwebfoundation.org/news/start-calculating-digital-carbon-emissions-in-5-minutes-with-co2-js/
const $cf79059e4e797253$var$isHostedSustainably = document.getElementById("is-hosted-sustainably");
(0, $bec6b2fd1d53da18$export$2e2bcd8739ae039).check($cf79059e4e797253$var$URL).then((result)=>{
    $cf79059e4e797253$var$isHostedSustainably.innerText = result ? "The site ifieldnotes.org is hosted sustainably" : "The site ifieldnotes.org is not hosted sustainably";
});
// See https://developers.thegreenwebfoundation.org/co2js/tutorials/getting-started-node/
// Sustainable Web Design selector
const $cf79059e4e797253$var$swdEmissions = document.getElementById("swd-emissions");
// Initiate a new co2 object using the Sustainable Web Design (SWD) model.
const $cf79059e4e797253$var$swd = new (0, $919f990d3a3bf3ae$export$2e2bcd8739ae039)({
    model: "swd"
});
// Use the perByte method to calculate emissions for 1 GB
let $cf79059e4e797253$var$emissions = $cf79059e4e797253$var$swd.perByte(1000000000);
// Report emissions
$cf79059e4e797253$var$swdEmissions.innerText = `Using the SWD perByte method the emissions for 1 GB is ${$cf79059e4e797253$var$emissions.toFixed(2)} grams of CO2`;
// OneByte selector
const $cf79059e4e797253$var$oneByteEmissions = document.getElementById("one-byte-emissions");
// Using the oneByte model
const $cf79059e4e797253$var$oneByte = new (0, $919f990d3a3bf3ae$export$2e2bcd8739ae039)({
    model: "1byte"
});
$cf79059e4e797253$var$emissions = $cf79059e4e797253$var$oneByte.perByte(1000000000);
// Report emissions
$cf79059e4e797253$var$oneByteEmissions.innerText = `Using the oneByte method the emissions for 1 GB is ${$cf79059e4e797253$var$emissions.toFixed(2)} grams of CO2`;


//# sourceMappingURL=sustainability.eb96a6c7.js.map
